import {pushToast} from "./pushToast";

export const handelPrice = (price) => {
    if(price!== undefined){
        return( new Intl.NumberFormat().format(price.toString().replace(/[^0-9]/g, '')));
    }
    return price



}

export const convertToWesternNumerals = (persianText) => {
    const persianToWesternNumerals = {
        '۰': '0',
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
    };

    // Use regular expression to replace Persian numerals with Western numerals
    const westernText = persianText.replace(/[\u06F0-\u06F9]/g, (match) => persianToWesternNumerals[match]);

    return westernText;
};
export const removeCama = (persianText) => {
    persianText = persianText.replace(/,/g, '')
    persianText = persianText.replace(/٬/g, '')
    // Use regular expression to replace Persian numerals with Western numerals
    persianText = convertToWesternNumerals(persianText)

    return persianText;
};
export  const HandelPaymentStatus = (id) =>{
    let componentToRender;
    switch (id) {
        case 0:
            componentToRender = <span className={"direction-ltr text-info"}>درحال بررسی</span>;
            break;
        case 1:
            componentToRender = <span className={"direction-ltr text-success"}>پرداخت شده</span>;

            break;
        case 2:
            componentToRender = <span className={"direction-ltr text-danger"}>لغو شده</span>;
            break;

        default:
            componentToRender = "خطا";
    }
    return componentToRender
}

export  const HandelCommissionCategory = (id,description,price=0) =>{

    let componentToRender;
    switch (id) {
        case 0:
            componentToRender = "عمومی";
            break;
        case 1:
            componentToRender = "واریز";

            break;
        case 2:
            componentToRender = "تبلیغات ورودی";
            break;

        case 3:
            componentToRender = "فعال سازی استخر " + description;
            break;

        case 4:
            componentToRender = "شارژ موبایل";
            break;

        case 5:
            componentToRender = "شارژ اینترنت";
            break;
        case 6:
            componentToRender = "پرداخت قبض";
            break;
        case 7:
            componentToRender = "طرح 1 - پارت " + description;
            break;
        case 8:
            componentToRender = "طرح 2 - پارت " + description;
            break;
        case 9:
            componentToRender = "طرح اول - " + description;
            break;
        case 10:
            componentToRender = price > 0 ? "واریز از درآمد" : "برداشت";
            break;
        default:
            componentToRender = "دیگر";
    }
    return componentToRender
}

export const copyToClipboard = (value) => {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, 99999); // For mobile devices
    document.execCommand('copy');
    document.body.removeChild(textarea);
    pushToast("کپی اطلاعات با موفقیت انجام گردید", "success");
}
export const isApp = () => {
    return navigator.userAgent.includes("KarsoodWebView")
};